import DataExtractionFieldBase from './DataExtractionFieldBase';

export const __typename = 'DataExtractionFieldTextDto';
export default class DataExtractionFieldText extends DataExtractionFieldBase {
  constructor(data = {}) {
    super({ ...data, __typename });
  }
}
